import React from "react";

interface NotesCardProps {
  notes: string;
}

/**
 * Displays the notes section in a bordered white card.
 */
const NotesCard: React.FC<NotesCardProps> = ({ notes }) => (
  <div className="flex flex-col gap-2 rounded-[10px] border border-[#E6E6E6] bg-white p-4">
    <p className="text-[11px] font-bold uppercase tracking-[0.6px] text-[#5C5C5C]">
      Notes
    </p>
    <p className="text-sm leading-[22px] text-[#1F1F1F]">{notes}</p>
  </div>
);

export default NotesCard;
